import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
import { LocalesConfig } from './locales';

const languageInitializer = () => {
  console.log(localStorage.getItem('lng'));
  if(localStorage.getItem("lng") !== null) {
    return localStorage.getItem("lng") as string;
  }
  else {
    localStorage.setItem("lng", LocalesConfig.defaultLanguage);
    return LocalesConfig.defaultLanguage;
  }
}

i18n.use(initReactI18next).init({
  resources,
  lng: languageInitializer(),
  supportedLngs: LocalesConfig.languageCodes,
  interpolation: {
    escapeValue: false,
  },
  react: { useSuspense: false },
});

export default i18n;
